import { Moon, Sun } from "lucide-react";
import type { JSX } from "react";
import { cn } from "@/lib/utils";

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  // Accessible name, for when no visible label sits next to the switch.
  label?: string;
}

export const ThemeToggleSwitch = (props: Props): JSX.Element => {
  return (
    <button
      type="button"
      aria-checked={props.checked}
      aria-label={props.label}
      role="switch"
      className={cn(
        "relative inline-flex h-7 w-14 cursor-pointer items-center rounded-full transition-colors",
        props.checked ? "bg-zinc-800" : "bg-zinc-200",
      )}
      onClick={() => {
        props.onChange(!props.checked);
      }}
    >
      <span
        className={cn(
          "pointer-events-none absolute top-0.5 left-0.5 h-6 w-6 rounded-full bg-white shadow-md ring-0 transition-transform flex items-center justify-center",
          props.checked ? "translate-x-7" : "translate-x-0",
        )}
      >
        {props.checked ? (
          <Moon className="h-4 w-4 text-zinc-800" data-testid="moon-icon" />
        ) : (
          <Sun className="h-4 w-4 text-yellow-500" data-testid="sun-icon" />
        )}
      </span>
    </button>
  );
};
